import Content from './Content';
import Sidebar from './Sidebar';
import Wrapper from './Wrapper';
import Footer from './Footer';
import Header from './Header';
import Title from './Title';
import WaldoBubble from './WaldoBubble';
import StickyFooter from './StickyFooter';

const CreateWizardLayout = {
  Wrapper,
  Content,
  Sidebar,
  Footer,
  Header,
  Title,
  WaldoBubble,
  StickyFooter,
};

export default CreateWizardLayout;
